/*
 * @format
 */

import { all, call, delay, race, take } from 'redux-saga/effects';

import * as types from '../action-types';
import { GLOBAL_TIMEOUT } from '../utils/timeout';

function* sendAndWaitAck(action) {
  yield call(action.sendWsMessage, action.message);

  const response = yield take(
    a =>
      (a.type === types.WEBSOCKET_SI_SETTINGS_UPDATE_RECEIVED ||
        a.type === types.WEBSOCKET_SI_SETTINGS_UPDATE_REJECTED) &&
      a.data.requestId === action.message.data.requestId,
  );

  return response;
}

function* siSettingsQueue() {
  while (true) {
    const action = yield take(types.SI_SETTINGS_UPDATE);

    yield call(action.onStart);

    const { timeout, response } = yield race({
      timeout: delay(GLOBAL_TIMEOUT),
      response: call(sendAndWaitAck, action),
    });

    yield call(action.onResolve);

    if (timeout) {
      yield call(action.onTimeout);
    } else if (response.type === types.WEBSOCKET_SI_SETTINGS_UPDATE_REJECTED) {
      yield call(action.onError);
    }
  }
}

function* siSettings() {
  yield all([call(siSettingsQueue)]);
}

export default siSettings;
